module.exports = __webpack_public_path__ + "static/img/bk.c2d2b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/depositActivity/bk.png
// module id = FE9t
// module chunks = 0